export default __webpack_public_path__ + "static/media/help-illustration02.113ff304.svg";